import { usePageContext } from '../contexts/page-context';

import type { FeatureFlags } from '@web-platform/shared-travel-tools-types/src/page-context';

export const useFeatureFlags = (): FeatureFlags => usePageContext().featureFlags;
